<template>
  <div class="container-fluid footer py-5 wow fadeIn" data-wow-delay="0.1s">
    <div class="container">
      <div class="row g-5 py-5">
        <div class="col-lg-3 col-md-6">
          <a href="/" class="d-inline-block mb-4">
            <img src="/img/logo.png" alt="Safari Strives Logo" style="max-height: 60px; width: auto;">
          </a>
          <h4 class="text-dark fw-bold mb-4">Contact Info</h4>
          <p class="mb-2 text-dark"><i class="fa fa-map-marker-alt me-3"></i>4922 134th St, Crestwood, IL</p>
          <p class="mb-2 text-dark"><i class="fa fa-phone-alt me-3"></i>US: +1 (331)-814-9549</p>
          <p class="mb-2 text-dark"><i class="fa fa-phone-alt me-3"></i>RW: (+25) 0785191825</p>
          <p class="mb-2 text-dark"><i class="fa fa-envelope me-3"></i>contact@safaristrives.org</p>
        </div>
        <div class="col-lg-3 col-md-6">
          <h4 class="text-dark fw-bold mb-4">Connect With Us</h4>
          <div class="d-flex flex-column">
            <a class="btn btn-link text-dark text-start p-0 mb-2" href="https://www.instagram.com/safaristrives" target="_blank">
              <i class="fab fa-instagram me-2"></i>Instagram
            </a>
            <a class="btn btn-link text-dark text-start p-0 mb-2" href="https://www.youtube.com/@safaristrives" target="_blank">
              <i class="fab fa-youtube me-2"></i>YouTube
            </a>
            <a class="btn btn-link text-dark text-start p-0 mb-2" href="https://www.linkedin.com/company/safaristrives" target="_blank">
              <i class="fab fa-linkedin-in me-2"></i>LinkedIn
            </a>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <h4 class="text-dark fw-bold mb-4">Quick Links</h4>
          <router-link to="/about" class="btn btn-link text-dark">About Us</router-link>
          <router-link to="/services" class="btn btn-link text-dark">Our Services</router-link>
          <router-link to="/gallery" class="btn btn-link text-dark">Gallery</router-link>
          <router-link to="/contact" class="btn btn-link text-dark">Contact Us</router-link>
        </div>
        <div class="col-lg-3 col-md-6">
          <h4 class="text-dark fw-bold mb-4">Gallery</h4>
          <div class="row g-2">
            <div class="col-4">
              <router-link to="/gallery#gallery-section" class="footer-gallery-link">
                <img class="img-fluid w-100" src="/img/gallery-event-1.jpg" alt="Gallery Event">
              </router-link>
            </div>
            <div class="col-4">
              <router-link to="/gallery#gallery-section" class="footer-gallery-link">
                <img class="img-fluid w-100" src="/img/gallery-event-2.jpg" alt="Gallery Event">
              </router-link>
            </div>
            <div class="col-4">
              <router-link to="/gallery#gallery-section" class="footer-gallery-link">
                <img class="img-fluid w-100" src="/img/gallery-event-3.jpg" alt="Gallery Event">
              </router-link>
            </div>
            <div class="col-4">
              <router-link to="/gallery#gallery-section" class="footer-gallery-link">
                <img class="img-fluid w-100" src="/img/gallery-event-4.jpg" alt="Gallery Event">
              </router-link>
            </div>
            <div class="col-4">
              <router-link to="/gallery#gallery-section" class="footer-gallery-link">
                <img class="img-fluid w-100" src="/img/gallery-event-5.jpg" alt="Gallery Event">
              </router-link>
            </div>
            <div class="col-4">
              <router-link to="/gallery#gallery-section" class="footer-gallery-link">
                <img class="img-fluid w-100" src="/img/gallery-event-6.jpg" alt="Gallery Event">
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="copyright pt-5">
        <div class="row">
          <div class="col-12 text-center">
            <span class="text-dark">Designed by Safari Strives, All right Reserved</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.footer-gallery-link {
  display: block;
  overflow: hidden;
  border-radius: 4px;
  transition: transform 0.3s ease;
}

.footer-gallery-link:hover {
  transform: scale(1.05);
}

.footer-gallery-link img {
  transition: opacity 0.3s ease;
}

.footer-gallery-link:hover img {
  opacity: 0.8;
}
</style>
